var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7791 8.63178C12.5686 8.63178 12.398 8.8024 12.398 9.01286C12.398 9.22332 12.5686 9.39394 12.7791 9.39394C12.9895 9.39394 13.1602 9.22332 13.1602 9.01286C13.1602 8.8024 12.9895 8.63178 12.7791 8.63178Z",
    fill: "#5A40A4",
    stroke: "#5A40A4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96951 8.63178C8.75905 8.63178 8.58843 8.8024 8.58843 9.01286C8.58843 9.22332 8.75905 9.39394 8.96951 9.39394C9.17997 9.39394 9.35059 9.22332 9.35059 9.01286C9.35059 8.8024 9.17997 8.63178 8.96951 8.63178Z",
    fill: "#5A40A4",
    stroke: "#5A40A4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15896 8.63178C4.9485 8.63178 4.77789 8.8024 4.77789 9.01286C4.77789 9.22332 4.9485 9.39394 5.15896 9.39394C5.36943 9.39394 5.54004 9.22332 5.54004 9.01286C5.54004 8.8024 5.36943 8.63178 5.15896 8.63178Z",
    fill: "#5A40A4",
    stroke: "#5A40A4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.00005C4.58172 1.00005 1 4.58177 1 9.00005C1 13.4183 4.58172 17 9 17C13.4183 17 17 13.4183 17 9.00005C17 4.58177 13.4183 1.00005 9 1.00005Z",
    stroke: "#5A40A4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.9221b3982241e9e37c09d737ea434be7.svg";
export { ForwardRef as ReactComponent };